<template>
    <div class="list_container">
        <div v-for="(item, index) in listData" :key="index" @click="setActiopFunGroup(item)" class="centerAlign">
            <div class="group_item" :class="item.id === activeItem ? 'activeItem' : ''" :style="{
                border: `1px solid ${color3}`,
                color: item.id === activeItem ? customStyles.active_font_color : customStyles.font_color,

            }">
                <img :src="item.customIcon" alt="">

            </div>
            <div class="group_name" :style="{ color: item.id === activeItem ? '#fff' : '' }">{{ $t(item.showName) }}</div>
        </div>
    </div>
    <div v-if="showGameList">
        <GamePopup ref="gameListRef" />
    </div>
</template>

<script setup lang="ts">
import { emitWithPreviewCheck, GroupList, setActiveItemFromClick, setFirstActiveItem } from '@/view/home/supportScript';
import { ref, onMounted, computed, onBeforeMount, watch, nextTick } from 'vue'
import GamePopup from '@/view/game/gamePopup.vue';

const customStyles = ref({
    active_background_color: '',
    active_font_color: "",
    border_color: "",
    font_color: ""
})
const props = defineProps<{
    listData: GroupList[],
    itemData: {
        styles: {
            active_background_color: string,
            active_font_color: string,
            border_color: string,
            font_color: string
        }
    },
}>()
const localActiveItem = ref<string | number>('')
const gameListRef = ref()
const showGameList = ref(false)

const activeItem = computed({
    get: () => localActiveItem.value || props.listData[0]?.id || '',
    set: (val) => {
        localActiveItem.value = val
    }
})
const emits = defineEmits(['showGameList'])

const hexWithAlpha = (hex: string, alpha: number) => {
    return hex + Math.round(alpha * 255).toString(16).padStart(2, '0')
}
const color1 = computed(() => customStyles.value.active_background_color)
const color2 = computed(() => hexWithAlpha(color1.value, 0))
const color3 = computed(() => hexWithAlpha(color1.value, 0.5))
const color4 = computed(() => hexWithAlpha(color1.value, 0.04))

const setActiopFunGroup = async (item: any) => {
    setActiveItemFromClick(item, localActiveItem)
    await nextTick()
    gameListRef.value?.selectGroup(item)
}

const setActiveItem = () => {
    setFirstActiveItem(props.listData, localActiveItem)
}
watch(activeItem, async (val) => {
    if (activeItem.value != props.listData[0].id) {
        showGameList.value = true
    } else {
        showGameList.value = false
    }
    emits('showGameList', showGameList.value)
})
defineExpose({
    setActiveItem,
    setActiopFunGroup
})

onBeforeMount(() => {
    setActiveItem();
});

onMounted(() => {
    customStyles.value.active_background_color = props.itemData.styles.active_background_color
    customStyles.value.active_font_color = props.itemData.styles.active_font_color
    customStyles.value.border_color = props.itemData.styles.border_color
    customStyles.value.font_color = props.itemData.styles.font_color
})
</script>
<style scoped>
.list_container {
    display: flex;
    flex-direction: row;
    align-items: center;
    white-space: nowrap;
    overflow-x: auto;
    scrollbar-width: none !important;
    transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);
    transition-property: transform;
    transition-duration: 0ms;
    margin: 15px 0 0;
}

.list_container::-webkit-scrollbar {
    display: none;
}

.group_item {
    flex-direction: column;
    position: relative;
    background: #11001fab;
    margin: 0 3px 0;
    border-radius: 15px;
    padding: 10px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    width: 20px;
    height: 20px;
}

.group_item img {
    max-width: 100%;
}

.group_name {
    text-align: center;
    font-size: 11px;
    padding-top: 5px;
    color: #ffffff80;
}

.activeItem {
    background-image: radial-gradient(circle at 50% 116%, #9e4e6cdb 0%, rgb(174 90 194 / 0%) 47%), linear-gradient(180deg, rgb(130 55 95 / 20%) 0%, rgba(240, 168, 83, 0.04) 100%);
    border: 1px solid #4b38477d !important;
}

.centerAlign {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding: 0 1px
}
</style>